import { useEffect, useState } from "react";
import { supabase } from "../../supabase";
import { Link, useNavigate } from "react-router-dom";
import { toBase64 } from "../../functions/base64";
import '../../styles/ProjectList.css';
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import { IoIosAdd } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";

export default function OnlineProjectList() {
  const [projects, setProjects] = useState([]);
  const [user, setUser] = useState();
  const nav = useNavigate();

  useEffect(() => {
    checkUser();
  }, []);

  // Sprawdzamy, czy użytkownik jest zalogowany
  const checkUser = async () => {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error || !user) {
      alert("Nie jesteś zalogowana! Zaloguj się.");
      nav("/login");
      return;
    }
    setUser(user);
    loadProjects(user.id);
  };

  // Pobieranie projektów dla zalogowanego użytkownika
  const loadProjects = async (userId) => {
    const { data, error } = await supabase
      .from('projects')
      .select('*')
      .eq('user_id', userId); // tylko projekty zalogowanego użytkownika

    if (error) console.error(error);
    else setProjects(data);
  };



  return (
    <div className="projectlist-wrapper">
      <Link to="/online/OnlineCreateProject" className="fixButton"><IoIosAdd /></Link>

      <ProjectHeader
              headerTitle={'Lista projektów'}
      />
      {projects.length === 0 && <p>Brak projektów. Stwórz pierwszy!</p>}
      <div className="project-grid">
        {projects.map(p => (
          <Link 
            key={p.id}
            to={`/online/project/${p.id}`}
            className="project-tile">
            <h3>{p.title}</h3>
            <span>{p.actualwords}/{p.words}</span>
            <progress value={p.actualwords} max={p.words} />
          </Link>
        ))}
      </div>


      <Link to="/" className="BackfixButton"><IoIosArrowBack /></Link>
    </div>
  );
}
